/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close" |
*
* @param {Desktop_Banner_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_close_aria_label = /** @type {((inputs?: Desktop_Banner_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vicino")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрывать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerca")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭")
	if (locale === "ja") return /** @type {LocalizedString} */ ("近い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar")
	return /** @type {LocalizedString} */ ("Close")
});